export default __webpack_public_path__ + "static/media/share.711d47fb.svg";